import React from 'react';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import * as styles from './CardBanner.module.scss';

const CARD_BANNER_BANNER_FRAGMENT = gql(`
  fragment CardBanner_banner on Image {
    original
  }
`);

const CardBanner = ({
  banner,
  height,
}: {
  banner: DocumentType<typeof CARD_BANNER_BANNER_FRAGMENT>;
  height: number;
}) => {
  const { original } = banner;

  return original ? (
    <div
      className={styles.banner}
      style={{ backgroundImage: `url(${original})`, height }}
    />
  ) : null;
};

export default CardBanner;
